import { Fragment } from "react";
import * as React from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Home } from "@mui/icons-material";
import { reset } from "../redux/profile/profileSlice";
import { RemoveTreatTeamLocalStore } from "../utils/storage";
import { setStorePermissions, setUserStores, storeSet } from "../redux/store/storeSlice";
import { ServiceApi } from "../services/index.service";
import { Backdrop, CircularProgress, Divider } from "@mui/material";
import { StoreDropdown } from "./shared/StoreDropdown";
import { defaultTourStatus, updateTourStatus } from "../redux/userOnboarding/userOnboardingSlice";
import { useSnackbar } from "notistack";

const navigation = [
  {
    name: "Flavor Portal", //"Today's Flavors",
    id: 1,
    link: "",
    comp: "treatteam/flavors",
    text: "FlavorBoard",
  },
  {
    name: "Digital Recipe Portal",
    id: 2,
    link: "",
    comp: "treatteam/recipes",
    text: "DigitalRecipePortal",
  },
  {
    name: "Flavor Admin", //"Manage Flavors",
    id: 3,
    link: "",
    comp: "treatteam/manage-flavors",
    text: "FlavorAdmin",
  },
  {
    name: "Digital Menu Board",
    id: 4,
    link: "",
    comp: "treatteam/board-administration",
    text: "DigitalMenuBoard",
  },
  {
    name: "Digital Drive Thru Board", // "Drive Thru",
    id: 8,
    link: "",
    comp: "treatteam/drive-thru",
    text: "DigitalDriveThruBoard",
  },
  {
    name: "Flavor Driven Treat Admin", //"Manage Flavor Driven Treats",
    id: 9,
    link: "",
    comp: "treatteam/flavor-driven-treats",
    text: "FlavorDrivenTreatAdmin",
  },
  {
    name: "Hours of Operation",
    id: 10,
    link: "",
    comp: "treatteam/hours-of-operation",
    text: "HoursOfOperation",
  },
  {
    name: "Shop Website Customization", // "Website Customization",
    id: 11,
    link: "",
    comp: "shop-website-customization",
    text: "ShopWebsiteCustomization",
  },
  {
    name: "Cool Alerts",
    id: 13,
    link: "",
    comp: "cool-alerts",
    text: "CoolAlerts",
  },
  // {
  //   name: "Online Order Portal",
  //   id: 14,
  //   link: "https://loyalty.ritasice.com/login",
  //   comp: "",
  //   text: "OnlineOrderPortal",
  // },
  // {
  //   name: "Pre-Sell Board Configuration",
  //   id: 15,
  //   link: "",
  //   comp: "pre-sell-board",
  //   text: "PreSellBoardConfiguration",
  // },
  {
    name: "Production Sheet",
    id: 16,
    link: "",
    comp: "treatteam/production",
    text: "ProductionSheet",
  },
  // {
  //   name: "Buy Merchandise",
  //   id: 17,
  //   link: "",
  //   comp: "treatteam/purchase-merchendise",
  //   text: "BuyMerchendize",
  // },
  // {
  //   name: "Edit Options",
  //   id: 18,
  //   link: "https://dmb.ritasice.com/",
  //   comp: "",
  //   text: "EditOptions",
  // },
];
export default function TTHeader({ userType = "" }) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const data = useSelector((state) => state);
  const dispatch = useDispatch();
  const location = useLocation();
  const serviceapi = new ServiceApi();
  const [loading, setLoading] = React.useState(false);
  const [store, setStore] = React.useState(null);
  const [storeList, setStoreList] = React.useState([]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const logout = (e) => {
    e.preventDefault();
    RemoveTreatTeamLocalStore();
    dispatch(storeSet(""));
    dispatch(setUserStores([]));
    dispatch(setStorePermissions(""));
    dispatch(reset(null));
  };
  
  const startTour = async (e, closeMenu) => {
    e.preventDefault();
    closeMenu()
    setLoading(true);
    const tourAPIResponse = await serviceapi.updateStatusForTourGuide(defaultTourStatus, data?.profile?.uid, data?.profile?.user_name);
    setLoading(false);
    if (tourAPIResponse?.statusCode === 200)
      dispatch(updateTourStatus(tourAPIResponse?.response?.data?.tourStatus));
    else enqueueSnackbar("Something went wrong!", {
      anchorOrigin: { vertical: "top", horizontal: "right", }, variant: "error",
    });
  }

  const openSite = (lnk) => {
    if (lnk.link !== "") {
      switch (lnk.text) {
        case "OnlineOrderPortal":
          let link = lnk.link
          switch (process.env.REACT_APP_ENVIRONMENT) {
            case "UAT":
              link = "https://ritasfranchises.okta.com/home/ritasfranchises_ooloyaltydashboardstage_1/0oa1uf4sx4rvWwVCl1d8/aln1uf4vg565PZTjI1d8"
              break;
            case "TRAIN":
              link = "https://ritasfranchises.okta.com/home/ritasfranchises_ooloyaltydashboardstage_1/0oa1uf4sx4rvWwVCl1d8/aln1uf4vg565PZTjI1d8"
              break;
            case "PROD":
              link="https://ritasfranchises.okta.com/home/ritasfranchises_ooloyaltydashboard_1/0oa1ugzdlzwXqzkwU1d8/aln1ugzhpwkTzf3341d8"
              break;
            default:
              link = lnk.link
              break;
          }
          window.open(link);
          break;
        default:
          break;
      }
    } else {
      navigate(`/${lnk.comp}`);
    }
  };

  const havePermissionToView = (menu) => {
    return data?.storage?.permissions?.[menu] === true;
  };

  React.useEffect(() => {
    setStore(data?.storage?.store);
  }, [data?.storage?.store]);

  React.useEffect(() => {
    if (data?.profile?.user_name) {
      getFCUserStores("all");
    }
  }, [data?.profile?.user_name]);

  const getFCUserStores = async (fcname) => {
    const req = {
      role: data?.profile?.role,
      user_name: data?.profile?.user_name,
      fsm_name: fcname,
    };
    setLoading(true);
    const response = await serviceapi.fetchFCStores(req);
    dispatch(setUserStores(response));
    setLoading(false);
    setStoreList(response || []);
    if (data?.storage?.store && Object.keys(data?.storage?.store).length) {
      setStore(data?.storage?.store);
    } else {
      setStore(response[0]);
      dispatch(storeSet(response[0]));
    }
  };

  const handleStoreChange = (event) => {
    setStore(event);
    dispatch(storeSet(event));
  };

  const basepath = (userType === 'DMB') ? 'dmb' : 'treatteam';

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Disclosure
        as="nav"
        style={{ zIndex: 300 }}
        className="h-16 fixed top-0 left-0 right-0 ritas-menu shadow-sm border-b border-gray-200 bg-white"
      >
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <div className="flex h-16 justify-between">
                <div className="flex items-center">
                  <NavLink
                    to={data?.profile?.role ? `/${basepath}` : `/${basepath}/login`}
                    className="flex cursor-pointer app-logo-tour-selector"
                  >
                    <div className="flex items-center">
                      <div className="flex flex-shrink-0 items-center">
                        <img
                          className="block h-10 w-auto lg:hidden"
                          src="../../assets/images/logo.png"
                          alt="Ritas Logo"
                        />
                        <img
                          className="hidden h-12 w-auto lg:block"
                          src="../../assets/images/logo.png"
                          alt="Ritas Logo"
                        />
                      </div>
                    </div>
                   <div className="hidden md:block text-center cursor-pointer text-[#D41042] items-center px-2 pt-4 not-italic font-bold" >
                      <p className="leading-4">{process.env.REACT_APP_NAV_HEADER_NAME}</p><p className="text-[10px] text-right text-secondary">{process.env.REACT_APP_NAV_SUB_HEADER_NAME}</p>
                    </div>
                  </NavLink>
                  {data?.profile && (
                    <>
                    <Divider variant="middle" orientation="vertical" className="ml-[6px] mr-4" />
                      <StoreDropdown store={store} storeList={storeList} handleStoreChange={handleStoreChange} />
                    </>
                   )}
                  {location.pathname !== "/" &&
                    location.pathname !== `/${basepath}/manage-flavors` &&
                    location.pathname !== `/${basepath}` ? (
                    <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                      {/* {navigation.map((item) => (
                        <NavLink
                          key={item.name}
                          to={item.href}
                          className={({ isActive, isPending }) =>
                            classNames(
                              isActive
                                ? "border-primary text-primary"
                                : isPending
                                ? "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                                : "",
                              "uppercase inline-flex items-center px-1 pt-1 border-b-2 text-sm font-display font-medium"
                            )
                          }
                          aria-current={item.current ? "page" : undefined}>
                          {item.name}
                        </NavLink>
                      ))} */}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="hidden sm:ml-6 sm:flex sm:items-center">
                  {data?.profile && (
                    <div className="cursor-pointer">
                      <NavLink to={`/${basepath}`}>
                        <div className="flex">
                          <Home color="success" />{" "}
                        </div>
                      </NavLink>
                    </div>
                  )}
                  {/* Profile dropdown */}
                  {data?.profile && (
                    <Menu as="div" className="relative ml-6">
                      <div className="profile-tour-selector">
                        <Menu.Button className="flex max-w-xs items-center bg-white text-sm focus:outline-none group">
                          <div className="flex gap-2 items-center">
                            <span className="sr-only">Open user menu</span>
                            <div className="flex flex-col items-center">
                              <span className="font-sans font-medium text-gray-700">
                                {`${data?.profile?.user_name}`}
                              </span>
                              <span className="self-end font-sans text-xs font-normal text-gray-700">
                                {data?.profile?.role}
                              </span>
                            </div>
                            <MoreVertOutlinedIcon />
                          </div>
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-240 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <Menu.Item>
                              {({ close }) => (
                                <Disclosure.Button
                                  key="start_tour"
                                  onClick={(e) => startTour(e, close)}
                                  className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100 hover:text-gray-800 whitespace-nowrap"
                                >
                                  Start tour
                                </Disclosure.Button>
                              )}
                            </Menu.Item>
                          <Disclosure.Button
                            key="logout"
                            as="a"
                            onClick={(e) => logout(e)}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-800"
                          >
                            Logout
                          </Disclosure.Button>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  )}
                </div>
                {data?.profile && (
                  <div className="-mr-2 flex items-center sm:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      ) : (
                        <Bars3Icon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      )}
                    </Disclosure.Button>
                  </div>
                )}
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden bg-white shadow-md">
              <div className="space-y-1 pt-2 pb-3">
                {navigation.map((item) => {
                  return havePermissionToView(item.text) ? (
                    <Disclosure.Button
                      key={item.name}
                      as="a"
                      onClick={() => openSite(item)}
                      className={classNames(
                        item.current
                          ? "bg-primary-light border-primary text-primary"
                          : "border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800",
                        "block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
                      )}
                      aria-current={item.current ? "page" : undefined}
                    >
                      {item.name}
                    </Disclosure.Button>
                  ) : (
                    ""
                  );
                })}
              </div>
              {data?.profile && (
                <div className="border-t border-gray-200 pt-4 pb-3">
                  <div className="flex items-center px-4">
                    <div>
                      <div className="text-base font-medium text-gray-800">
                        {`${data?.profile?.user_name}`}
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 space-y-1">
                    {/* {userNavigation.map((item) => (
                      <Disclosure.Button
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                      >
                        {item.name}
                      </Disclosure.Button>
                    ))} */}
                    <Disclosure.Button
                      key="logout"
                      as="a"
                      onClick={(e) => logout(e)}
                      className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                    >
                      Logout
                    </Disclosure.Button>
                  </div>
                </div>
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </>
  );
}
